import React from "react";
import PropTypes from "prop-types";
import { slice, get } from "lodash";
import styled from "styled-components";
import PopularPreviewCard from "../PostPreviewCards/PopularPreviewCard";
import useWindowSize from "../Helpers/use-window-size";

const PostSection = styled.section`
  position: relative;
  padding: 0;
  margin: 32px 0;
  display: flex;
  flex-direction: column;
  ${props => props.theme.media.desktopUp`
    flex-direction: row;
    width: inherit;
`};
`;

const EditorPickCards = ({ posts }) => {
  const edges = get(posts, "edges");
  const isMobileView = useWindowSize().width < 991;
  const cardsPerView = isMobileView ? 1 : 3;
  return (
    <PostSection>
      {slice(edges, 0, cardsPerView).map(post => (
        <PopularPreviewCard key={post.node.slug} node={post.node} />
      ))}
    </PostSection>
  );
};

EditorPickCards.propTypes = {
  posts: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          categories: PropTypes.arrayOf(PropTypes.string),
          slug: PropTypes.string,
          title: PropTypes.string
        })
      })
    )
  })
};

EditorPickCards.defaultProps = {
  posts: { edges: [] }
};

export default EditorPickCards;
